<template>
  <div>
    <svg viewBox="0 0 6000.57 5994.99" :width="svgWidth" :height="svgHeight">
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 3000 3000"
        @click="handleLink()"
      >
        <path
          class="cls-1"
          d="M4500,4500H1500V1500H4500ZM2159.56,2870.23c2.07-1.18,2.72-2.52.52-4.22a662.93,662.93,0,0,1,9.5-65.79c2-1.13,2.86-2.42.64-4.19,1.09-6.54,2.13-13.09,3.31-19.62.53-2.95-.1-4.71-3.06-6.33-12.63-6.94-25-14.27-37.55-21.43l-79.48-45.46c-8.82-5-17.6-10.16-26.49-15.09-3.92-2.17-6.73-1-6.5,3.1.49,8.56-2.91,16.26-4.6,24.31-4.37,20.79-9,41.51-13.57,62.26-2,1.14-2.79,2.44-.59,4.17q-3.69,21.92-7.37,43.81c-2,1.15-2.82,2.46-.61,4.2a21.28,21.28,0,0,1-1.52,9.79c-2,1.25-2.42,2.64-.36,4.23l-5.43,43.77c-2.14,1.19-2.62,2.57-.49,4.25-.82,14-1.74,27.91-3.73,41.77-2.87,2.61-2.83,5.36-.38,8.22q-.79,13-1.6,26-3.89,3.84-.37,8-.49,16.47-1,32.94c-.27,9.29-1.12,8.76,8.24,8.76q72.45,0,144.91-.07c5.25,0,11.68,2.24,15.45-1.14,3.43-3.07.69-9.58,2.13-14.4,3.31-4.57,2.94-9.28.52-14.06a504,504,0,0,1,3.7-58c1.91-1.23,1.93-2.58.25-4a78,78,0,0,1,1.55-17.78c2.06-1.22,2.65-2.58.43-4.22-.05-5.33,0-10.64,1.68-15.78,2.41-1.91,2.72-4,.44-6.21A37.26,37.26,0,0,1,2159.56,2870.23Zm1738.86,38A77.39,77.39,0,0,1,3900,2926c-1.68,1.44-1.67,2.79.24,4a82.49,82.49,0,0,1,1.66,20c-2.31,2.14-1.94,4.12.34,6,2.35,18.17,1.8,36.5,3,54.73.49,7.56-.29,7.6,7.8,7.6q42.88-.06,85.77,0c21.94,0,43.89,0,65.83,0,12.22,0,10.88,1.39,10.45-11.46-.32-9.63-.55-19.27-.82-28.9,2.32-3.44,2.33-6.79-.44-10q-.8-13-1.6-26c2.47-2.86,2.48-5.61-.38-8.22-2-13.19-2.66-26.5-3.6-39.78,2.17-2.32,2.07-4.41-.62-6.25a244.57,244.57,0,0,1-3.3-27.77c2.13-1.66,1.45-3-.47-4.22a39.71,39.71,0,0,1-1.66-11.76c2.07-1.6,1.62-3-.36-4.24a21.26,21.26,0,0,1-1.52-9.78c2.23-1.75,1.36-3.06-.61-4.21l-7.37-43.8c2.22-1.74,1.41-3-.59-4.18a25.92,25.92,0,0,1-1.28-3.75q-6.75-36.83-15.94-73.12a95.4,95.4,0,0,0-2.82-10.53c-1.27-3.33-2.56-4.63-7-2.08-7.61,4.38-15.17,8.91-22.81,13.27-19.84,11.31-39.16,23.58-59.3,34.32-18.37,9.8-36.1,20.7-54.47,30.46-7.71,4.1-8.2,5.5-6.73,14,.9,5.23,1.61,10.5,2.41,15.75-2.24,1.77-1.32,3.06.64,4.19a662.93,662.93,0,0,1,9.5,65.79c-2.21,1.7-1.54,3,.52,4.22a37.26,37.26,0,0,1,1.43,11.79c-2.29,2.24-2,4.3.44,6.21a37.66,37.66,0,0,1,1.51,13.8C3895.54,2904.34,3895.88,2906.4,3898.42,2908.24ZM4070.19,3184c.11-6,0-12.06,1.55-18,2.78-2.54,2.82-5.23.43-8,.07-3,0-6,.22-9,.45-8.32.86-16.64,1.54-24.94.36-4.29-1.06-6.24-5.51-5.82-2.31.22-4.66,0-7,0l-155-.11c-5,4.16-5.35,5.9-2.51,13.77a212.1,212.1,0,0,1-1.72,34c-2.36,1.88-2.7,3.87-.34,6,.13,6,.13,12-1.44,17.82-2.79,1.87-2.74,4-.46,6.2a87.78,87.78,0,0,1-1.73,19.81c-2,1.22-2.64,2.56-.39,4.17a52.27,52.27,0,0,1-1.65,16c-1.83,1.23-2,2.56-.27,4-1.63,19.44-4.12,38.77-7.63,58-1.84,1.1-2.44,2.38-.56,4a14.52,14.52,0,0,1-1.34,7.81c-2.07,1.18-2.64,2.53-.5,4.21-1.65,10.16-3.18,20.35-5,30.48-3.6,20.3-7.91,40.45-12.56,60.53-2.07,9-1.56,9.71,6.32,14.11,16,8.94,32.06,17.71,47.87,27,14,8.16,28.28,15.63,42.56,23.23,11,5.86,21.25,13.16,31.9,19.7,7.47,4.58,8.13,4.27,11-3.72,9.77-27.24,17.06-55.22,24.65-83.12,2.67-.52,3.89-1.61,1.62-4.09,3.29-14.51,6.81-29,9.8-43.54,4.67-22.72,9-45.51,13.43-68.27,2.28-1.09,2.69-2.47.65-4.22a26.54,26.54,0,0,1,1.54-9.79c2-1.14,2.84-2.44.61-4.19a22.63,22.63,0,0,1,1.55-10c1.9-1.18,2.13-2.51.36-4a29.33,29.33,0,0,1,1.39-9.8c2.07-1.16,2.75-2.5.55-4.21l5.67-52C4071.73,3186.86,4072.05,3185.54,4070.19,3184ZM2167.57,3309.78a14.52,14.52,0,0,1-1.34-7.81c1.89-1.62,1.28-2.89-.55-4-3.51-19.19-6-38.53-7.64-58,1.76-1.46,1.56-2.79-.26-4a52.1,52.1,0,0,1-1.66-16c2.26-1.62,1.61-3-.39-4.18A87.74,87.74,0,0,1,2154,3196c2.29-2.25,2.32-4.34-.45-6.21-1.63-5.84-1.51-11.83-1.48-17.8,2.26-2.14,1.94-4.14-.35-6-1.24-11.3-2.2-22.61-1.68-34,2.58-4.18,2.78-8.27-.5-12.21-2.84-3.51-6.79-2-10.26-2.05q-74.81-.14-149.61-.06c-2.32,0-4.65,0-7,.11-2.88.09-2.62,2.38-2.94,4.26-2.37,3.45-2.37,6.79.43,10l1.59,24c-2.34,3.46-2.46,6.82.48,10,1.6,5.9,1.45,11.94,1.56,18-1.87,1.5-1.55,2.82.32,4q2.83,26,5.68,52c-2.21,1.72-1.51,3.06.55,4.22a29.31,29.31,0,0,1,1.39,9.79c-1.78,1.51-1.54,2.83.36,4a22.71,22.71,0,0,1,1.54,10c-2.24,1.75-1.33,3,.61,4.19a26.31,26.31,0,0,1,1.54,9.78c-2,1.76-1.62,3.13.65,4.23.48,1.91,1.08,3.79,1.4,5.73,5.92,35.64,13.3,71,21.83,106.08-1.84,1.63-1.35,2.92.58,4-.91,3.16,1.78,5.33,2.27,8,3.15,17.11,9,33.45,13.59,50.16,1.23,4.51,5.91,7.95,4.09,13.38-1.31,3.64.72,6.11,3,8.5,1.73.82,1.44,2.18,1,3.59-.65,1.25-.33,2.08,1.07,2.45,1.75.74,1.5,2.06,1,3.45-1.34,3.68.68,6.15,3,8.51,2.43,2.52,4.34,6,8.2,1,1.87-2.42,5.36-3.63,8.19-5.26q20.11-11.58,40.27-23.09c9.54-5.42,19-11.15,28.73-16,6.51-3.26,12.64-7.31,19.12-10.59,9-4.54,17.29-10.65,26.77-14.65a21.92,21.92,0,0,0,8.81-7.31c1.77-2.47-1-5.61-1.57-8.5-.84-4.57-1.85-9.11-2.87-13.65-6.52-29.18-12.78-58.42-16.84-88.07C2170.22,3312.32,2169.63,3311,2167.57,3309.78Zm-76.22,288.06c-1.56-.12-3.22-.32-3.52,1.84-.22,1.55.78,2.17,2.15,2.37l10,21.9c-.51,1.41.05,2.11,1.48,2.24,3.89,7.07,8.8,13.78,11.45,21.28,4.72,13.35,13,24.68,19.23,37.14,7.13,14.22,16.82,26.91,25,40.54,5.72,9.57,12.58,18.36,19,27.44,6.61,9.3,13.36,18.56,20,27.86,6.29,8.84,14.09,16.62,20.79,25.07,7.17,9,15.21,17.27,22.61,26,10.93,12.93,23.58,24.44,35.83,36.21,6.13,5.89,12.75,11.41,19.29,16.72,5.39,4.37,11.65,8.55,16.48,13.21,11.43,11,24.77,19.15,37.55,28,27.5,19,56.65,35.14,88.83,45.29,5.16,1.63,8.32,1.41,12.31-2.38,15.91-15.14,32.17-29.9,48.31-44.8q67.16-62,134.39-123.83c4.32-4,5.94-7.94,5.92-13.75-.22-51.31-.13-102.63-.13-153.94v-7.75c-4.84-1.18-7,2.1-9.68,4.36-7.1,6-11.75,14.59-19.69,19.54-6.62,4.12-11.83,9.57-16.84,15.26-3.72,4.23-7.46,8.26-12.26,11.32a65.8,65.8,0,0,0-15.36,14.17c-2.54,3.12-5,6.49-8.24,8.47-14,8.51-23.27,22.21-35.84,32.44-12.17,9.92-23.61,21.09-35,32.12-6.6,6.41-13,12.9-20.27,18.62-5.36,4.21-10.53,8.79-13.83,15.38s-8,7.5-16,4.85a193.65,193.65,0,0,1-49.68-24.33c-28.1-19.48-51.54-43.84-72.29-70.93a486.72,486.72,0,0,1-33.44-50.27,697,697,0,0,1-34.26-66.65c-8.74-19.47-16.89-39.18-23.74-59.38-1.26-3.7-3.54-3.71-6.06-3.2-2.09.43-4,1.82-5.92,2.92-13.22,7.65-26.35,15.46-39.63,23-20.39,11.56-41.12,22.54-61.18,34.64C2103.2,3590.44,2096.21,3592.5,2091.35,3597.84ZM3329.93,2323.75c-.08,1.53-1.22,2.33-2.34,2.91-11.3,5.91-20.92,14.23-31.29,21.49-1.49-.6-2.27,0-2.41,1.51-.21,1.9-1.79,2.73-3.15,3.41-8.12,4.09-15.23,9.65-22.44,15.08-1.5-.59-2.27,0-2.41,1.52-2.24,5-8.47,4.61-11.5,8.53-1.51-.58-2.32,0-2.47,1.55-2.32,4.88-8.45,4.59-11.52,8.46-1.51-.6-2.33-.07-2.48,1.53-2.06,5.15-8.71,4.23-11.37,8.59-1.54-.67-2.42-.21-2.6,1.49-2.28,4.92-8.61,4.34-11.47,8.45-1.52-.64-2.38-.15-2.55,1.5s-1.27,2.27-2.39,2.87c-11.25,6-20.86,14.29-31.23,21.52-1.51-.58-2.28,0-2.42,1.54-2.9,4.16-7,6.66-11.63,8.42-1.49-.51-2.25.07-2.36,1.6-2.28,5-8.43,4.64-11.54,8.47-1.5-.58-2.31,0-2.45,1.54-2.19,5-8.58,4.41-11.42,8.54-1.51-.61-2.38-.13-2.56,1.51s-1.28,2.23-2.39,2.87c-16,9.25-30.21,21-45.29,31.48-1.49-.57-2.25,0-2.38,1.54-2.23,5-8.44,4.66-11.51,8.53-1.5-.58-2.31,0-2.46,1.53-2.14,5.1-8.54,4.48-11.46,8.53-1.53-.61-2.37-.1-2.52,1.54-2.23,5-8.54,4.42-11.46,8.46-1.5-.6-2.36-.11-2.54,1.52-13.94,9.51-12.39,12.17-24.75,3.19q-23.27-16.91-46.63-33.68c-23.69-16.94-47.48-33.72-71.17-50.66q-46-32.93-92-66-46.36-33.28-92.71-66.6-43.1-31-86.19-62-35.1-25.2-70.25-50.36T2486,2155.41q-18.18-13-36.33-26.13c-4.2-3-8.62-4.55-13.74-2.25-12.75,5.73-25.64,11.18-38.27,17.2-6.54,3.12-12.56,7.43-19,10.64-15.64,7.8-30,17.57-44.35,27.32-1.52-.6-2.32-.05-2.45,1.56-.55.77-.92,1.9-1.67,2.26-12.32,5.92-21.59,16-32.34,24.06-11.21,8.36-20.7,19.06-30.78,28.9-10.69,10.43-22.19,20.26-31.46,31.85-8.39,10.49-17.85,20.06-25.93,30.92-6.94,9.33-13.33,19.4-21.7,27.73-3.83,3.82-4.83,9.51-8.43,13.3-14.07,14.82-23,33.19-33.77,50.14-6.32,9.93-12.34,20.41-18.08,30.85s-11.07,21.18-17.14,31.49c-14.1,24-25.23,49.48-36.08,75.06-7,16.42-13.53,33-20.07,49.6-2.7,6.87-2.31,8.12,4.36,11.24,5,2.34,9.39,5.56,14.11,8.28q31.11,17.9,62.26,35.73c10,5.7,19.64,12.19,30.17,16.58,8.42,3.5,15.39,9.22,23.7,12.9,8.62,3.82,8.82,5,11.06-3.13,1.49-5.41,2.36-11,4.08-16.34,20.22-62.87,43.34-124.5,77.58-181.38,14.35-23.84,29.86-46.9,48.62-67.48,21.93-24.06,45.11-46.53,74.92-61.38a263.58,263.58,0,0,1,34.18-14.5c3.56-1.18,7.07-2.32,9.27,2.47.59,1.28,2.51,1.95,3.83,2.89q44.23,31.66,88.5,63.31c8.18,5.83,16.53,11.41,24.8,17.11-.18,1.26.37,1.89,1.64,1.88,3.69,3.37,9.89,2.91,12.36,8.13q-.26,1.86,1.62,1.86c3.71,3.34,9.88,3,12.38,8.15-.24,1.26.27,1.89,1.57,1.86l26.44,18.11c-.17,1.25.37,1.88,1.63,1.88,1.42.83,2.91,1.56,4.24,2.51,40.35,28.83,80.58,57.84,121.07,86.47,17.62,12.45,34.44,26.07,53.26,36.79-.08,1.2-.16,2.4-.25,3.6l-27.8-3.34c-1.24-1.71-2.56-1.93-4-.26-20.69-1-41.37-1-62.05-.06-1.44-1.8-2.76-1.51-4,.25-13.84,2-27.74,3.65-41.52,6a389.5,389.5,0,0,0-75.77,21,384.88,384.88,0,0,0-63.64,31.62,340.83,340.83,0,0,0-36.84,26c-9.3,7.67-19,14.79-26.82,24.1a18.23,18.23,0,0,1-4.57,3.81,36.56,36.56,0,0,0-12.19,11.6c-5.68,9.07-14.08,15.68-21,23.41-10.41,11.57-18.61,24.54-28,36.7-13.76,17.86-23.39,38.25-32.58,58.63-9.54,21.16-17.25,43-21.7,66.09-4.54,23.57-8.71,47.13-11.23,71-1.78,1.24-2,2.57-.23,4-.09,5.66-.07,11.32-.28,17-1.65,45.28,5,89.61,16.85,133.09,8.74,32,23.54,61.67,40.35,90.22,14.68,24.93,33.18,47,52.06,68.83,15.1,17.42,33,31.93,50.95,46.15a361.31,361.31,0,0,0,70.22,43.52c12.51,5.91,25.47,10.73,38.11,16.26,15.88,6.94,33,9.32,49.33,14.2,7.56,2.25,16.18,2.75,24.29,4.24,1.09,2.21,2.43,2.81,4.22.69,4.09-.24,8,.68,12,1.6,1.15,1.81,2.48,2.15,4,.45,8.3.59,16.6,1.28,24.91,1.76,53.79,3.08,106.27-4.44,157.5-20.58a97.52,97.52,0,0,0,17.85-7.18c6-3.32,12.43-5.27,18.53-7.92,8.41-3.64,17.34-7.05,24.79-11.74,17.77-11.18,36.32-21.27,52.89-34.32,8.21-6.47,16.93-12.34,24.22-20.27-23.62-22.82-43.16-47.58-61.11-73.79-2,1.58-3.28,2.61-4.55,3.67-78.89,65.75-169,89.91-269.73,70.21C2487,3257.22,2375.63,3058.2,2441,2877.13a316.16,316.16,0,0,1,359.55-202.64c61.73,12.3,115,41,160,85.08,3.71,3.63,5.27,6,1.93,11.51-48.21,79.42-65.61,165.76-56.85,257.79,9,94,49.64,173.51,111.85,243,7.26,8.11,15.62,15.15,24,22.18,7.15,6,14.17,12.41,21.41,18.28a351.76,351.76,0,0,0,58.67,38.12c16.34,8.58,33.4,15.44,50.42,22.54,16,6.67,33,9.37,49.38,14.22,7.58,2.24,16.2,2.75,24.32,4.24,1.09,2.21,2.43,2.81,4.22.69,4.09-.24,8,.68,12,1.6,1.15,1.81,2.48,2.15,4,.45,2,0,4,0,6,.16a424.66,424.66,0,0,0,118.32-4.49,385.29,385.29,0,0,0,52.19-13.19c6.17-2,11.84-5.21,18.14-6.75,10.24-2.5,19.78-7.26,29.14-11.59,9.65-4.47,19.14-9.93,28.49-15.36,27.85-16.14,53.93-34.59,77.51-56.42a403.22,403.22,0,0,0,65.37-78.51,421.47,421.47,0,0,0,58.3-143.22c1.69-8.12,2.84-16.37,4.24-24.55,1.92-1.21,2.53-2.58.5-4.26q.86-9,1.72-18c1.75-1.24,2-2.57.25-4,.61-19.34.58-38.69,0-58,1.78-1.44,1.55-2.76-.23-4q-.86-9-1.73-18c2.09-1.66,1.45-3-.47-4.22-3.45-21.59-7.5-43-14.07-63.93-8.67-27.56-19.53-54.18-33.64-79.51-15.68-28.14-33.66-54.56-55.5-78.26a412.59,412.59,0,0,0-88.64-73.2,435.91,435.91,0,0,0-121.85-51c-19.72-5-39.87-7.35-60-9.72-1.23-1.71-2.56-1.93-4-.26-20.69-1-41.37-1-62.05-.06-1.44-1.8-2.76-1.51-4,.25q-12.37,1.59-24.76,3.17c-1.6.2-3.47.66-4.41-1.12-1.32-2.51,1.07-3.38,2.45-4.59.74-.65,1.67-1.1,2.48-1.69,25.77-18.6,51.31-37.52,77.35-55.74,37.39-26.17,74.27-53,111.39-79.58,52.64-37.63,105.49-75,158.13-112.61,3.07-2.19,6.05-3.05,9.1-1.8,8.36,3.42,17.45,5.62,25.23,9.66,27,14.06,52.88,30.41,73.62,53.06,9,9.87,17.91,20.08,26.12,30.87a541.5,541.5,0,0,1,46.82,72.57c23.27,43.52,41.92,89.11,56.93,136.18,4.91,15.37,9,31.09,16.17,46.12,4.39-2.41,8.46-4.56,12.44-6.84,18.67-10.69,37.15-21.7,56-32,11.45-6.26,23-12.55,34.24-19,12-6.84,24-13.85,35.78-21.27,4.5-2.84,4.78-2.85,2.78-8.28-7.12-19.4-15-38.49-23.07-57.52a994.07,994.07,0,0,0-63.45-123.77,879.08,879.08,0,0,0-60.47-88.23c-24-30.73-49.57-59.88-78.51-86.11a530.71,530.71,0,0,0-157.73-99.18c-4-1.6-7.47-1.45-10.85,1-7.74,5.63-15.44,11.33-23.15,17-1.52-.67-2.45-.26-2.67,1.46-2.1,5.08-8.6,4.28-11.35,8.5-1.52-.6-2.44-.16-2.64,1.52-1,2.71-3.11,3.82-5.76,4.25-1.51-.51-2.23.11-2.31,1.63-2.34,4.88-8.43,4.64-11.55,8.46-1.5-.57-2.29,0-2.44,1.53-2.23,5-8.48,4.58-11.5,8.51-1.53-.58-2.34,0-2.47,1.57-2.25,5-8.54,4.46-11.48,8.47-1.52-.62-2.36-.13-2.53,1.51-2.24,5-8.57,4.41-11.44,8.5-1.52-.59-2.38-.1-2.54,1.55s-1.28,2.25-2.4,2.84c-11.22,6-20.88,14.26-31.25,21.5-1.51-.58-2.28,0-2.41,1.55-2.32,4.91-8.39,4.72-11.56,8.48-1.51-.61-2.3-.06-2.44,1.52-2.26,5-8.44,4.64-11.53,8.49-1.5-.58-2.3,0-2.46,1.53-6.21,5.9-13.92,9.69-20.75,14.74-13.53,10-27.23,19.81-40.86,29.69-1.51-.58-2.28,0-2.41,1.55-2.25,5-8.41,4.67-11.49,8.52-1.5-.6-2.32-.08-2.49,1.52-2.2,5-8.5,4.52-11.48,8.5-1.52-.6-2.35-.08-2.5,1.54-2.26,4.94-8.52,4.46-11.47,8.47C3331,2321.64,3330.11,2322.14,3329.93,2323.75Zm85.76,1298.39v8.18q0,78.49,0,157c0,1.67,0,3.34.06,5,.18,3.06,1,6,3.87,7.51,9.7,5,15.21,14.5,23.13,21.38,5,4.33,11.12,7.65,15.14,12.7,9.35,11.74,22.64,19.17,32,30.73,5.3,6.52,13.82,9.55,18.86,16,10.87,14,26.89,22.33,37.88,36.12,3,3.74,8.36,5.57,11.4,9.29,13.07,16,31,26.87,44.34,42.48a7.7,7.7,0,0,0,3,2.45c2.72.92,5.19,2.41,8.53.94,11.18-4.92,23.17-8.3,33.67-14.34,11.41-6.55,23.5-11.68,34.71-18.76,21.85-13.8,43.2-28.2,63.48-44.21,25.43-20.1,48.14-43.08,70.48-66.45,19.3-20.19,36.44-42.23,53-64.64a763.65,763.65,0,0,0,42.54-64.49,977.2,977.2,0,0,0,55-106.92c1.72-3.92.58-5.05-2.55-6.74-9.22-5-18.3-10.27-27.39-15.53-19.64-11.36-39.21-22.86-58.88-34.17-11.71-6.74-23.63-13.12-35.3-19.92-4.29-2.5-6.79-1.66-8,2.92-.38,1.42-1.64,2.13-2,3.28-7.13,23.27-16.7,45.57-26.48,67.8-10.16,23.09-21.53,45.6-33.83,67.56-5.32,9.51-12,18.5-18.22,27.61-10.18,14.88-20.09,30.21-32.58,43.06-10.92,11.23-21.36,23.11-34.17,32.69-11.58,8.65-22.66,17.83-35.42,24.81-11.65,6.37-23.41,12.35-36.15,16.3-5,1.56-8.45,1.14-11.75-3.64-3.18-4.6-7.57-8.41-11.7-12.27-18-16.82-36.16-33.5-54.2-50.29q-50.11-46.62-100.19-93.27C3431.29,3636.05,3424.35,3630,3415.69,3622.14Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M3332.47,2322.24c3-4,9.21-3.53,11.47-8.47l2.5-1.54c3-4,9.28-3.47,11.48-8.5l2.49-1.52c3.08-3.85,9.24-3.56,11.49-8.52l2.41-1.55c13.63-9.88,27.33-19.68,40.86-29.69,6.83-5,14.54-8.84,20.75-14.74l2.46-1.53c3.09-3.85,9.27-3.5,11.53-8.49.82-.5,1.63-1,2.44-1.52,3.17-3.76,9.24-3.57,11.56-8.48l2.41-1.55c10.37-7.24,20-15.5,31.25-21.5,1.12-.59,2.31-1.3,2.4-2.84l2.54-1.55c2.87-4.09,9.2-3.54,11.44-8.5l2.53-1.51c2.94-4,9.23-3.5,11.48-8.47l2.47-1.57c3-3.93,9.27-3.5,11.5-8.51l2.44-1.53c3.12-3.82,9.21-3.58,11.55-8.46l2.31-1.63c2.65-.43,4.79-1.54,5.76-4.25l2.64-1.52c2.75-4.22,9.25-3.42,11.35-8.5l2.67-1.46c7.71-5.66,15.41-11.36,23.15-17,3.38-2.45,6.89-2.6,10.85-1a530.71,530.71,0,0,1,157.73,99.18c28.94,26.23,54.48,55.38,78.51,86.11a879.08,879.08,0,0,1,60.47,88.23,994.07,994.07,0,0,1,63.45,123.77c8.1,19,16,38.12,23.07,57.52,2,5.43,1.72,5.44-2.78,8.28-11.73,7.42-23.78,14.43-35.78,21.27-11.27,6.43-22.79,12.72-34.24,19-18.86,10.31-37.34,21.32-56,32-4,2.28-8.05,4.43-12.44,6.84-7.2-15-11.26-30.75-16.17-46.12-15-47.07-33.66-92.66-56.93-136.18a541.5,541.5,0,0,0-46.82-72.57c-8.21-10.79-17.07-21-26.12-30.87-20.74-22.65-46.59-39-73.62-53.06-7.78-4-16.87-6.24-25.23-9.66-3-1.25-6-.39-9.1,1.8-52.64,37.64-105.49,75-158.13,112.61-37.12,26.54-74,53.41-111.39,79.58-26,18.22-51.58,37.14-77.35,55.74-.81.59-1.74,1-2.48,1.69-1.38,1.21-3.77,2.08-2.45,4.59.94,1.78,2.81,1.32,4.41,1.12q12.39-1.56,24.76-3.17a3.31,3.31,0,0,0,4-.25c20.68-.94,41.36-1,62.05.06a3.21,3.21,0,0,0,4,.26c20.14,2.37,40.29,4.76,60,9.72a435.91,435.91,0,0,1,121.85,51,412.59,412.59,0,0,1,88.64,73.2c21.84,23.7,39.82,50.12,55.5,78.26,14.11,25.33,25,51.95,33.64,79.51,6.57,20.88,10.62,42.34,14.07,63.93a4.22,4.22,0,0,0,.47,4.22q.87,9,1.73,18a3.28,3.28,0,0,0,.23,4c.54,19.35.57,38.7,0,58a3.29,3.29,0,0,0-.25,4q-.86,9-1.72,18a4.11,4.11,0,0,0-.5,4.26c-1.4,8.18-2.55,16.43-4.24,24.55a421.47,421.47,0,0,1-58.3,143.22,403.22,403.22,0,0,1-65.37,78.51c-23.58,21.83-49.66,40.28-77.51,56.42-9.35,5.43-18.84,10.89-28.49,15.36-9.36,4.33-18.9,9.09-29.14,11.59-6.3,1.54-12,4.72-18.14,6.75a385.29,385.29,0,0,1-52.19,13.19,424.66,424.66,0,0,1-118.32,4.49c-2-.2-4-.12-6-.16a3.31,3.31,0,0,0-4-.45c-3.94-.92-7.88-1.84-12-1.6a4.22,4.22,0,0,0-4.22-.69c-8.12-1.49-16.74-2-24.32-4.24-16.4-4.85-33.38-7.55-49.38-14.22-17-7.1-34.08-14-50.42-22.54a351.76,351.76,0,0,1-58.67-38.12c-7.24-5.87-14.26-12.31-21.41-18.28-8.43-7-16.79-14.07-24-22.18-62.21-69.5-102.9-149-111.85-243-8.76-92,8.64-178.37,56.85-257.79,3.34-5.51,1.78-7.88-1.93-11.51-45-44-98.29-72.78-160-85.08A316.16,316.16,0,0,0,2441,2877.13c-65.4,181.07,46,380.09,234.23,416.91,100.7,19.7,190.84-4.46,269.73-70.21,1.27-1.06,2.58-2.09,4.55-3.67,17.95,26.21,37.49,51,61.11,73.79-7.29,7.93-16,13.8-24.22,20.27-16.57,13.05-35.12,23.14-52.89,34.32-7.45,4.69-16.38,8.1-24.79,11.74-6.1,2.65-12.57,4.6-18.53,7.92a97.52,97.52,0,0,1-17.85,7.18c-51.23,16.14-103.71,23.66-157.5,20.58-8.31-.48-16.61-1.17-24.91-1.76a3.31,3.31,0,0,0-4-.45c-3.94-.92-7.88-1.84-12-1.6a4.22,4.22,0,0,0-4.22-.69c-8.11-1.49-16.73-2-24.29-4.24-16.38-4.88-33.45-7.26-49.33-14.2-12.64-5.53-25.6-10.35-38.11-16.26a361.31,361.31,0,0,1-70.22-43.52c-17.93-14.22-35.85-28.73-50.95-46.15-18.88-21.78-37.38-43.9-52.06-68.83-16.81-28.55-31.61-58.19-40.35-90.22-11.86-43.48-18.5-87.81-16.85-133.09.21-5.65.19-11.31.28-17a3.26,3.26,0,0,0,.23-4c2.52-23.86,6.69-47.42,11.23-71,4.45-23.12,12.16-44.93,21.7-66.09,9.19-20.38,18.82-40.77,32.58-58.63,9.38-12.16,17.58-25.13,28-36.7,6.95-7.73,15.35-14.34,21-23.41a36.56,36.56,0,0,1,12.19-11.6,18.23,18.23,0,0,0,4.57-3.81c7.81-9.31,17.52-16.43,26.82-24.1a340.83,340.83,0,0,1,36.84-26,384.88,384.88,0,0,1,63.64-31.62,389.5,389.5,0,0,1,75.77-21c13.78-2.35,27.68-4,41.52-6a3.31,3.31,0,0,0,4-.25c20.68-.93,41.36-1,62.05.06a3.21,3.21,0,0,0,4,.26l27.8,3.34c1.45.73,3.71,1.46,4.07-.16.44-2-1.82-3-3.82-3.44-18.82-10.72-35.64-24.34-53.26-36.79-40.49-28.63-80.72-57.64-121.07-86.47-1.33-1-2.82-1.68-4.24-2.51l-1.63-1.88-26.44-18.11-1.57-1.86c-2.5-5.19-8.67-4.81-12.38-8.15l-1.62-1.86c-2.47-5.22-8.67-4.76-12.36-8.13-.54-.63-1.09-1.25-1.64-1.88-8.27-5.7-16.62-11.28-24.8-17.11q-44.3-31.59-88.5-63.31c-1.32-.94-3.24-1.61-3.83-2.89-2.2-4.79-5.71-3.65-9.27-2.47a263.58,263.58,0,0,0-34.18,14.5c-29.81,14.85-53,37.32-74.92,61.38-18.76,20.58-34.27,43.64-48.62,67.48-34.24,56.88-57.36,118.51-77.58,181.38-1.72,5.33-2.59,10.93-4.08,16.34-2.24,8.09-2.44,6.95-11.06,3.13-8.31-3.68-15.28-9.4-23.7-12.9-10.53-4.39-20.19-10.88-30.17-16.58q-31.17-17.8-62.26-35.73c-4.72-2.72-9.1-5.94-14.11-8.28-6.67-3.12-7.06-4.37-4.36-11.24,6.54-16.59,13.1-33.18,20.07-49.6,10.85-25.58,22-51.1,36.08-75.06,6.07-10.31,11.42-21.08,17.14-31.49s11.76-20.92,18.08-30.85c10.8-16.95,19.7-35.32,33.77-50.14,3.6-3.79,4.6-9.48,8.43-13.3,8.37-8.33,14.76-18.4,21.7-27.73,8.08-10.86,17.54-20.43,25.93-30.92,9.27-11.59,20.77-21.42,31.46-31.85,10.08-9.84,19.57-20.54,30.78-28.9,10.75-8,20-18.14,32.34-24.06.75-.36,1.12-1.49,1.67-2.26l2.45-1.56c14.38-9.75,28.71-19.52,44.35-27.32,6.44-3.21,12.46-7.52,19-10.64,12.63-6,25.52-11.47,38.27-17.2,5.12-2.3,9.54-.76,13.74,2.25q18.16,13.06,36.33,26.13,35.1,25.17,70.22,50.31t70.25,50.36q43.11,31,86.19,62,46.35,33.3,92.71,66.6,46,33,92,66c23.69,16.94,47.48,33.72,71.17,50.66q23.4,16.73,46.63,33.68c12.36,9,10.81,6.32,24.75-3.19l2.54-1.52c2.92-4,9.23-3.49,11.46-8.46l2.52-1.54c2.92-4.05,9.32-3.43,11.46-8.53l2.46-1.53c3.07-3.87,9.28-3.52,11.51-8.53l2.38-1.54c15.08-10.51,29.33-22.23,45.29-31.48,1.11-.64,2.3-1.33,2.39-2.87l2.56-1.51c2.84-4.13,9.23-3.53,11.42-8.54l2.45-1.54c3.11-3.83,9.26-3.51,11.54-8.47l2.36-1.6c4.63-1.76,8.73-4.26,11.63-8.42l2.42-1.54c10.37-7.23,20-15.56,31.23-21.52,1.12-.6,2.28-1.35,2.39-2.87l2.55-1.5c2.86-4.11,9.19-3.53,11.47-8.45l2.6-1.49c2.66-4.36,9.31-3.44,11.37-8.59l2.48-1.53c3.07-3.87,9.2-3.58,11.52-8.46l2.47-1.55c3-3.92,9.26-3.54,11.5-8.53.8-.51,1.6-1,2.41-1.52,7.21-5.43,14.32-11,22.44-15.08,1.36-.68,2.94-1.51,3.15-3.41l2.41-1.51c10.37-7.26,20-15.58,31.29-21.49,1.12-.58,2.26-1.38,2.34-2.91ZM3314.3,3300.5c174.77.15,316-140.95,316.12-315.86.14-174.65-141.21-316.24-315.83-316.35-174.42-.11-316.28,141.64-316.29,316C2998.29,3159.07,3139.5,3300.35,3314.3,3300.5Zm-63.63-723.32c.16-1.31-.42-2.26-1.38-2.14a6.53,6.53,0,0,0-3.34,1.47,1.13,1.13,0,0,0,.77,2C3248.15,2578.49,3249.93,2578.88,3250.67,2577.18Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M3415.69,3622.14c8.66,7.81,15.6,13.91,22.36,20.19q50.13,46.59,100.19,93.27c18,16.79,36.18,33.47,54.2,50.29,4.13,3.86,8.52,7.67,11.7,12.27,3.3,4.78,6.7,5.2,11.75,3.64,12.74-4,24.5-9.93,36.15-16.3,12.76-7,23.84-16.16,35.42-24.81,12.81-9.58,23.25-21.46,34.17-32.69,12.49-12.85,22.4-28.18,32.58-43.06,6.24-9.11,12.9-18.1,18.22-27.61,12.3-22,23.67-44.47,33.83-67.56,9.78-22.23,19.35-44.53,26.48-67.8.35-1.15,1.61-1.86,2-3.28,1.24-4.58,3.74-5.42,8-2.92,11.67,6.8,23.59,13.18,35.3,19.92,19.67,11.31,39.24,22.81,58.88,34.17,9.09,5.26,18.17,10.53,27.39,15.53,3.13,1.69,4.27,2.82,2.55,6.74a977.2,977.2,0,0,1-55,106.92,763.65,763.65,0,0,1-42.54,64.49c-16.58,22.41-33.72,44.45-53,64.64-22.34,23.37-45.05,46.35-70.48,66.45-20.28,16-41.63,30.41-63.48,44.21-11.21,7.08-23.3,12.21-34.71,18.76-10.5,6-22.49,9.42-33.67,14.34-3.34,1.47-5.81,0-8.53-.94a7.7,7.7,0,0,1-3-2.45c-13.38-15.61-31.27-26.49-44.34-42.48-3-3.72-8.42-5.55-11.4-9.29-11-13.79-27-22.16-37.88-36.12-5-6.48-13.56-9.51-18.86-16-9.4-11.56-22.69-19-32-30.73-4-5.05-10.16-8.37-15.14-12.7-7.92-6.88-13.43-16.36-23.13-21.38-2.91-1.5-3.69-4.45-3.87-7.51-.09-1.66-.06-3.33-.06-5q0-78.49,0-157Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M2100,3624l-10-21.9c2.08-.88.4-3,1.37-4.21,4.86-5.34,11.85-7.4,17.78-11,20.06-12.1,40.79-23.08,61.18-34.64,13.28-7.54,26.41-15.35,39.63-23,1.91-1.1,3.83-2.49,5.92-2.92,2.52-.51,4.8-.5,6.06,3.2,6.85,20.2,15,39.91,23.74,59.38a697,697,0,0,0,34.26,66.65,486.72,486.72,0,0,0,33.44,50.27c20.75,27.09,44.19,51.45,72.29,70.93a193.65,193.65,0,0,0,49.68,24.33c8,2.65,12.69,1.76,16-4.85s8.47-11.17,13.83-15.38c7.28-5.72,13.67-12.21,20.27-18.62,11.36-11,22.8-22.2,35-32.12,12.57-10.23,21.81-23.93,35.84-32.44,3.26-2,5.7-5.35,8.24-8.47a65.8,65.8,0,0,1,15.36-14.17c4.8-3.06,8.54-7.09,12.26-11.32,5-5.69,10.22-11.14,16.84-15.26,7.94-5,12.59-13.55,19.69-19.54,2.67-2.26,4.84-5.54,9.68-4.36v7.75c0,51.31-.09,102.63.13,153.94,0,5.81-1.6,9.79-5.92,13.75q-67.35,61.74-134.39,123.83c-16.14,14.9-32.4,29.66-48.31,44.8-4,3.79-7.15,4-12.31,2.38-32.18-10.15-61.33-26.26-88.83-45.29-12.78-8.85-26.12-17-37.55-28-4.83-4.66-11.09-8.84-16.48-13.21-6.54-5.31-13.16-10.83-19.29-16.72-12.25-11.77-24.9-23.28-35.83-36.21-7.4-8.77-15.44-17-22.61-26-6.7-8.45-14.5-16.23-20.79-25.07-6.63-9.3-13.38-18.56-20-27.86-6.44-9.08-13.3-17.87-19-27.44-8.15-13.63-17.84-26.32-25-40.54-6.24-12.46-14.51-23.79-19.23-37.14-2.65-7.5-7.56-14.21-11.45-21.28Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M1993.66,3268.07a22.71,22.71,0,0,0-1.54-10,3.24,3.24,0,0,0-.36-4,29.31,29.31,0,0,0-1.39-9.79,3.94,3.94,0,0,0-.55-4.22q-2.83-26-5.68-52a3.12,3.12,0,0,0-.32-4c-.11-6,0-12.07-1.56-18a19.62,19.62,0,0,0-.48-10l-1.59-24a17.43,17.43,0,0,0-.43-10c.32-1.88.06-4.17,2.94-4.26,2.32-.08,4.65-.11,7-.11q74.8,0,149.61.06c3.47,0,7.42-1.46,10.26,2.05a25.49,25.49,0,0,0,.5,12.21c-.52,11.38.44,22.69,1.68,34a6.55,6.55,0,0,0,.35,6c0,6-.15,12,1.48,17.8a7.62,7.62,0,0,0,.45,6.21,87.74,87.74,0,0,0,1.73,19.8,4,4,0,0,0,.39,4.18,52.1,52.1,0,0,0,1.66,16,3.16,3.16,0,0,0,.26,4c1.63,19.44,4.13,38.78,7.64,58a3.22,3.22,0,0,0,.55,4,14.52,14.52,0,0,0,1.34,7.81,4.25,4.25,0,0,0,.5,4.22c4.06,29.65,10.32,58.89,16.84,88.07,1,4.54,2,9.08,2.87,13.65.53,2.89,3.34,6,1.57,8.5a21.92,21.92,0,0,1-8.81,7.31c-9.48,4-17.76,10.11-26.77,14.65-6.48,3.28-12.61,7.33-19.12,10.59-9.75,4.88-19.19,10.61-28.73,16q-20.19,11.46-40.27,23.09c-2.83,1.63-6.32,2.84-8.19,5.26-3.86,5-5.77,1.48-8.2-1,.28-3.3-1.53-5.85-3-8.51.5-1.39.75-2.71-1-3.45l-1.07-2.45c.48-1.41.77-2.77-1-3.59.51-3.36-1.3-5.91-3-8.5,1.82-5.43-2.86-8.87-4.09-13.38-4.56-16.71-10.44-33.05-13.59-50.16-.49-2.64-3.18-4.81-2.27-8,1.14-1.53.39-2.8-.58-4-8.53-35.1-15.91-70.44-21.83-106.08-.32-1.94-.92-3.82-1.4-5.73a4.44,4.44,0,0,0-.65-4.23,26.31,26.31,0,0,0-1.54-9.78A4,4,0,0,0,1993.66,3268.07Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M3900.46,3189.8C3902,3184,3902,3178,3901.9,3172a6.7,6.7,0,0,0,.34-6,212.1,212.1,0,0,0,1.72-34c1.72-4.43-.07-9.5,2.51-13.77l155,.11c2.33,0,4.68.18,7,0,4.45-.42,5.87,1.53,5.51,5.82-.68,8.3-1.09,16.62-1.54,24.94-.17,3-.15,6-.22,9a12.9,12.9,0,0,0-.43,8c-1.58,5.89-1.44,11.93-1.55,18a3.16,3.16,0,0,0-.33,4l-5.67,52a3.92,3.92,0,0,0-.55,4.21,29.33,29.33,0,0,0-1.39,9.8,3.24,3.24,0,0,0-.36,4,22.63,22.63,0,0,0-1.55,10,4,4,0,0,0-.61,4.19,26.54,26.54,0,0,0-1.54,9.79,4.44,4.44,0,0,0-.65,4.22c-4.45,22.76-8.76,45.55-13.43,68.27-3,14.57-6.51,29-9.8,43.54l-1.62,4.09c-7.59,27.9-14.88,55.88-24.65,83.12-2.87,8-3.53,8.3-11,3.72-10.65-6.54-20.89-13.84-31.9-19.7-14.28-7.6-28.59-15.07-42.56-23.23-15.81-9.24-31.89-18-47.87-27-7.88-4.4-8.39-5.15-6.32-14.11,4.65-20.08,9-40.23,12.56-60.53,1.8-10.13,3.33-20.32,5-30.48a4.23,4.23,0,0,0,.5-4.21,14.52,14.52,0,0,0,1.34-7.81,3.24,3.24,0,0,0,.56-4c3.51-19.2,6-38.53,7.63-58a3.17,3.17,0,0,0,.27-4,52.27,52.27,0,0,0,1.65-16,3.92,3.92,0,0,0,.39-4.17A87.78,87.78,0,0,0,3900,3196,7.63,7.63,0,0,0,3900.46,3189.8Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M3900,2926a77.39,77.39,0,0,0-1.56-17.77,7.57,7.57,0,0,0-.59-6.2,37.66,37.66,0,0,0-1.51-13.8,7.38,7.38,0,0,0-.44-6.21,37.26,37.26,0,0,0-1.43-11.79,4,4,0,0,0-.52-4.22,662.93,662.93,0,0,0-9.5-65.79,4,4,0,0,0-.64-4.19c-.8-5.25-1.51-10.52-2.41-15.75-1.47-8.46-1-9.86,6.73-14,18.37-9.76,36.1-20.66,54.47-30.46,20.14-10.74,39.46-23,59.3-34.32,7.64-4.36,15.2-8.89,22.81-13.27,4.43-2.55,5.72-1.25,7,2.08a95.4,95.4,0,0,1,2.82,10.53q9.15,36.3,15.94,73.12a25.92,25.92,0,0,0,1.28,3.75,3.92,3.92,0,0,0,.59,4.18l7.37,43.8a3.89,3.89,0,0,0,.61,4.21,21.26,21.26,0,0,0,1.52,9.78,4,4,0,0,0,.36,4.24,39.71,39.71,0,0,0,1.66,11.76,4.19,4.19,0,0,0,.47,4.22,244.57,244.57,0,0,0,3.3,27.77c-.8,2.18-.28,4.23.62,6.25.94,13.28,1.57,26.59,3.6,39.78a13.36,13.36,0,0,0,.38,8.22q.81,13,1.6,26a17.46,17.46,0,0,0,.44,10c.27,9.63.5,19.27.82,28.9.43,12.85,1.77,11.42-10.45,11.46-21.94.06-43.89,0-65.83,0q-42.89,0-85.77,0c-8.09,0-7.31,0-7.8-7.6-1.19-18.23-.64-36.56-3-54.73a6.59,6.59,0,0,0-.34-6,82.49,82.49,0,0,0-1.66-20A3.43,3.43,0,0,0,3900,2926Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M2155.58,2908.23A78,78,0,0,0,2154,2926a3.43,3.43,0,0,0-.25,4,504,504,0,0,0-3.7,58c-.93,4.66-1.56,9.33-.52,14.06-1.44,4.82,1.3,11.33-2.13,14.4-3.77,3.38-10.2,1.13-15.45,1.14q-72.45.15-144.91.07c-9.36,0-8.51.53-8.24-8.76q.48-16.47,1-32.94a11.65,11.65,0,0,0,.37-8q.79-13,1.6-26a13.36,13.36,0,0,0,.38-8.22c2-13.86,2.91-27.81,3.73-41.77a3.87,3.87,0,0,0,.49-4.25l5.43-43.77a4,4,0,0,0,.36-4.23,21.28,21.28,0,0,0,1.52-9.79,3.87,3.87,0,0,0,.61-4.2q3.69-21.9,7.37-43.81a3.9,3.9,0,0,0,.59-4.17c4.54-20.75,9.2-41.47,13.57-62.26,1.69-8.05,5.09-15.75,4.6-24.31-.23-4.06,2.58-5.27,6.5-3.1,8.89,4.93,17.67,10.05,26.49,15.09l79.48,45.46c12.51,7.16,24.92,14.49,37.55,21.43,3,1.62,3.59,3.38,3.06,6.33-1.18,6.53-2.22,13.08-3.31,19.62a4,4,0,0,0-.64,4.19,662.93,662.93,0,0,0-9.5,65.79,4,4,0,0,0-.52,4.22,37.26,37.26,0,0,0-1.43,11.79,7.31,7.31,0,0,0-.44,6.21c-1.67,5.14-1.73,10.45-1.68,15.78A3.87,3.87,0,0,0,2155.58,2908.23Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2149.56,3002.08c-1-4.73-.41-9.4.52-14.06C2152.5,2992.8,2152.87,2997.51,2149.56,3002.08Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M3906.47,3118.22c-2.58,4.27-.79,9.34-2.51,13.77C3901.12,3124.12,3901.43,3122.38,3906.47,3118.22Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M2150,3132a25.49,25.49,0,0,1-.5-12.21C2152.82,3123.72,2152.62,3127.81,2150,3132Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M1981.78,3156a19.62,19.62,0,0,1,.48,10C1979.32,3162.86,1979.44,3159.5,1981.78,3156Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M1979.76,3122a17.43,17.43,0,0,1,.43,10C1977.39,3128.83,1977.39,3125.49,1979.76,3122Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M4074.24,2978a17.46,17.46,0,0,1-.44-10C4076.57,2971.18,4076.56,2974.53,4074.24,2978Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M4071.74,3166.08a12.9,12.9,0,0,1,.43-8C4074.56,3160.85,4074.52,3163.54,4071.74,3166.08Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M1980.2,2968a11.65,11.65,0,0,1-.37,8Q1976.32,2971.79,1980.2,2968Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4072.2,2942a13.36,13.36,0,0,1-.38-8.22C4074.68,2936.36,4074.67,2939.11,4072.2,2942Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1982.18,2933.76a13.36,13.36,0,0,1-.38,8.22C1979.35,2939.12,1979.31,2936.37,1982.18,2933.76Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2040.22,3473.61c1.68,2.59,3.49,5.14,3,8.5C2040.94,3479.72,2038.91,3477.25,2040.22,3473.61Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2046.23,3491.6c1.5,2.66,3.31,5.21,3,8.51C2046.91,3497.75,2044.89,3495.28,2046.23,3491.6Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2157.69,2888.23a7.31,7.31,0,0,1,.44-6.21C2160.41,2884.26,2160.1,2886.32,2157.69,2888.23Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3895.88,2882a7.38,7.38,0,0,1,.44,6.21C3893.92,2886.33,3893.59,2884.27,3895.88,2882Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M4068.22,2894c-.9-2-1.42-4.07-.62-6.25C4070.29,2889.56,4070.39,2891.65,4068.22,2894Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3897.83,2902a7.57,7.57,0,0,1,.59,6.2C3895.88,2906.4,3895.54,2904.34,3897.83,2902Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3901.88,2950a6.59,6.59,0,0,1,.34,6C3899.94,2954.15,3899.57,2952.17,3901.88,2950Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2152.07,3172a6.55,6.55,0,0,1-.35-6C2154,3167.85,2154.33,3169.85,2152.07,3172Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M3902.24,3166a6.7,6.7,0,0,1-.34,6C3899.54,3169.84,3899.88,3167.85,3902.24,3166Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M2154,3196a7.62,7.62,0,0,1-.45-6.21C2156.32,3191.66,2156.29,3193.75,2154,3196Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M3900.46,3189.8a7.63,7.63,0,0,1-.46,6.2C3897.72,3193.76,3897.67,3191.67,3900.46,3189.8Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1983.82,3184a3.12,3.12,0,0,1,.32,4C1982.27,3186.86,1982,3185.54,1983.82,3184Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4069.86,3188.06a3.16,3.16,0,0,1,.33-4C4072.05,3185.54,4071.73,3186.86,4069.86,3188.06Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3724.23,2934a4.22,4.22,0,0,1-.47-4.22C3725.68,2931,3726.32,2932.3,3724.23,2934Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M1986.4,2887.74a3.87,3.87,0,0,1-.49,4.25C1983.78,2890.31,1984.26,2888.93,1986.4,2887.74Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M2156.12,3220a4,4,0,0,1-.39-4.18C2157.73,3217,2158.38,3218.36,2156.12,3220Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M3898.27,3215.81a3.92,3.92,0,0,1-.39,4.17C3895.63,3218.37,3896.25,3217,3898.27,3215.81Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2158,3240a3.16,3.16,0,0,1-.26-4C2159.6,3237.21,2159.8,3238.54,2158,3240Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3896.23,3236a3.17,3.17,0,0,1-.27,4C3894.2,3238.54,3894.4,3237.21,3896.23,3236Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1989.82,3240a3.94,3.94,0,0,1,.55,4.22C1988.31,3243.1,1987.61,3241.76,1989.82,3240Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4063.64,3244.25a3.92,3.92,0,0,1,.55-4.21C4066.39,3241.75,4065.71,3243.09,4063.64,3244.25Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4060.29,2830a3.89,3.89,0,0,1-.61-4.21C4061.65,2826.89,4062.52,2828.2,4060.29,2830Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1991.76,3254.05a3.24,3.24,0,0,1,.36,4C1990.22,3256.88,1990,3255.56,1991.76,3254.05Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4061.89,3258.06a3.24,3.24,0,0,1,.36-4C4064,3255.55,4063.79,3256.88,4061.89,3258.06Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1993.66,3268.07a4,4,0,0,1,.61,4.19C1992.33,3271.12,1991.42,3269.82,1993.66,3268.07Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4059.73,3272.25a4,4,0,0,1,.61-4.19C4062.57,3269.81,4061.69,3271.11,4059.73,3272.25Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1995.81,3282a4.44,4.44,0,0,1,.65,4.23C1994.19,3285.17,1993.77,3283.8,1995.81,3282Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M4057.54,3286.26a4.44,4.44,0,0,1,.65-4.22C4060.23,3283.79,4059.82,3285.17,4057.54,3286.26Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2166.23,3302a3.22,3.22,0,0,1-.55-4C2167.51,3299.08,2168.12,3300.35,2166.23,3302Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3888.33,3298a3.24,3.24,0,0,1-.56,4C3885.89,3300.35,3886.49,3299.07,3888.33,3298Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2168.07,3314a4.25,4.25,0,0,1-.5-4.22C2169.63,3311,2170.22,3312.32,2168.07,3314Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2669.74,3391.46a4.22,4.22,0,0,1,4.22.69C2672.17,3394.27,2670.83,3393.67,2669.74,3391.46Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3245.78,3391.46a4.22,4.22,0,0,1,4.22.69C3248.21,3394.27,3246.87,3393.67,3245.78,3391.46Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M2685.93,3393.75a3.31,3.31,0,0,1,4,.45C2688.41,3395.9,2687.08,3395.56,2685.93,3393.75Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-8"
          d="M2802.06,2573.85c2,.4,4.26,1.4,3.82,3.44-.36,1.62-2.62.89-4.07.16C2801.9,2576.25,2802,2575.05,2802.06,2573.85Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M2019.69,3398.08c1,1.22,1.72,2.49.58,4C2018.34,3401,2017.85,3399.71,2019.69,3398.08Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M4032.69,3402.16l1.62-4.09C4036.58,3400.55,4035.36,3401.64,4032.69,3402.16Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3893.93,2866a4,4,0,0,1,.52,4.22C3892.39,2869.06,3891.72,2867.72,3893.93,2866Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2155.58,2908.23a3.87,3.87,0,0,1,.43-4.22C2158.23,2905.65,2157.64,2907,2155.58,2908.23Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-8"
          d="M3350.05,2574.11a3.21,3.21,0,0,1-4-.26C3347.49,2572.18,3348.82,2572.4,3350.05,2574.11Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-8"
          d="M2091.35,3597.84c-1,1.23.71,3.33-1.37,4.21-1.37-.2-2.37-.82-2.15-2.37C2088.13,3597.52,2089.79,3597.72,2091.35,3597.84Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3886.43,3309.79a4.23,4.23,0,0,1-.5,4.21C3883.79,3312.32,3884.36,3311,3886.43,3309.79Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2708,2573.79a3.31,3.31,0,0,1-4,.25C2705.19,2572.28,2706.51,2572,2708,2573.79Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-8"
          d="M2774,2574.11a3.21,3.21,0,0,1-4-.26C2771.45,2572.18,2772.77,2572.4,2774,2574.11Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3284,2573.79a3.31,3.31,0,0,1-4,.25C3281.23,2572.28,3282.55,2572,3284,2573.79Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3726.19,2956a3.28,3.28,0,0,1-.23-4C3727.74,2953.21,3728,2954.53,3726.19,2956Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2328.09,2954a3.26,3.26,0,0,1-.23,4C2326.08,2956.54,2326.31,2955.21,2328.09,2954Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2159.56,2870.23a4,4,0,0,1,.52-4.22C2162.28,2867.71,2161.63,2869.05,2159.56,2870.23Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M4064.3,2860a4.19,4.19,0,0,1-.47-4.22C4065.75,2856.94,4066.43,2858.29,4064.3,2860Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M4062.17,2844a4,4,0,0,1-.36-4.24C4063.79,2841,4064.24,2842.37,4062.17,2844Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3725.9,3018a3.29,3.29,0,0,1,.25-4C3727.87,3015.46,3727.65,3016.79,3725.9,3018Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3723.68,3040.28a4.11,4.11,0,0,1,.5-4.26C3726.21,3037.7,3725.6,3039.07,3723.68,3040.28Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M1992.19,2839.74a4,4,0,0,1-.36,4.23C1989.77,2842.38,1990.2,2841,1992.19,2839.74Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3262,3393.75a3.31,3.31,0,0,1,4,.45C3264.45,3395.9,3263.12,3395.56,3262,3393.75Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M1994.32,2825.75a3.87,3.87,0,0,1-.61,4.2C1991.5,2828.21,1992.34,2826.9,1994.32,2825.75Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3883.79,2796a4,4,0,0,1,.64,4.19C3882.47,2799.1,3881.55,2797.81,3883.79,2796Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2169.58,2800.22a4,4,0,0,1,.64-4.19C2172.44,2797.8,2171.55,2799.09,2169.58,2800.22Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M4052.31,2781.94a3.92,3.92,0,0,1-.59-4.18C4053.72,2778.9,4054.53,2780.2,4052.31,2781.94Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M2002.28,2777.77a3.9,3.9,0,0,1-.59,4.17C1999.49,2780.21,2000.27,2778.91,2002.28,2777.77Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M2153.78,2930a3.43,3.43,0,0,1,.25-4C2155.71,2927.45,2155.69,2928.8,2153.78,2930Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3900,2926a3.43,3.43,0,0,1,.24,4C3898.31,2928.8,3898.3,2927.45,3900,2926Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3580.65,2144.34l-2.67,1.46C3578.2,2144.08,3579.13,2143.67,3580.65,2144.34Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-5"
          d="M3566.63,2154.3l-2.64,1.52C3564.19,2154.14,3565.11,2153.7,3566.63,2154.3Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3558.23,2160.07l-2.31,1.63C3556,2160.18,3556.72,2159.56,3558.23,2160.07Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3544.37,2170.16l-2.44,1.53C3542.08,2170.13,3542.87,2169.59,3544.37,2170.16Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3530.43,2180.2l-2.47,1.57C3528.09,2180.16,3528.9,2179.62,3530.43,2180.2Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M2334.31,2182.19l-2.45,1.56C2332,2182.14,2332.79,2181.59,2334.31,2182.19Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3516.48,2190.24l-2.53,1.51C3514.12,2190.11,3515,2189.62,3516.48,2190.24Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3502.51,2200.25l-2.54,1.55C3500.13,2200.15,3501,2199.66,3502.51,2200.25Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3466.32,2226.14l-2.41,1.55C3464,2226.12,3464.81,2225.56,3466.32,2226.14Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3452.35,2236.17c-.81.51-1.62,1-2.44,1.52C3450.05,2236.11,3450.84,2235.56,3452.35,2236.17Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3374.31,2292.14l-2.41,1.55C3372,2292.12,3372.8,2291.56,3374.31,2292.14Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3360.41,2302.21l-2.49,1.52C3358.09,2302.13,3358.91,2301.61,3360.41,2302.21Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3332.47,2322.24l-2.54,1.51C3330.11,2322.14,3331,2321.64,3332.47,2322.24Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3296.3,2348.15l-2.41,1.51C3294,2348.11,3294.81,2347.55,3296.3,2348.15Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3268.3,2368.15c-.81.5-1.61,1-2.41,1.52C3266,2368.12,3266.8,2367.56,3268.3,2368.15Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3254.39,2378.2l-2.47,1.55C3252.07,2378.15,3252.88,2377.62,3254.39,2378.2Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3240.4,2388.21l-2.48,1.53C3238.07,2388.14,3238.89,2387.61,3240.4,2388.21Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3226.55,2398.33l-2.6,1.49C3224.13,2398.12,3225,2397.66,3226.55,2398.33Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M2565.85,2406.21c.55.63,1.1,1.25,1.64,1.88C2566.22,2408.1,2565.67,2407.47,2565.85,2406.21Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3212.48,2408.27l-2.55,1.5C3210.1,2408.12,3211,2407.63,3212.48,2408.27Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2579.85,2416.22l1.62,1.86Q2579.59,2418.08,2579.85,2416.22Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2593.85,2426.23l1.57,1.86C2594.12,2428.12,2593.61,2427.49,2593.85,2426.23Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3176.31,2434.16l-2.42,1.54C3174,2434.14,3174.8,2433.58,3176.31,2434.16Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3162.26,2444.12l-2.36,1.6C3160,2444.19,3160.77,2443.61,3162.26,2444.12Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2621.86,2446.2l1.63,1.88C2622.23,2448.08,2621.69,2447.45,2621.86,2446.2Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3148.36,2454.19l-2.45,1.54C3146.05,2454.15,3146.86,2453.61,3148.36,2454.19Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3134.49,2464.27l-2.56,1.51C3132.11,2464.14,3133,2463.66,3134.49,2464.27Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-6"
          d="M3084.25,2500.13l-2.38,1.54C3082,2500.14,3082.76,2499.56,3084.25,2500.13Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3070.36,2510.2l-2.46,1.53C3068.05,2510.15,3068.86,2509.62,3070.36,2510.2Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3056.44,2520.26l-2.52,1.54C3054.07,2520.16,3054.91,2519.65,3056.44,2520.26Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-7"
          d="M3042.46,2530.26l-2.54,1.52C3040.1,2530.15,3041,2529.66,3042.46,2530.26Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3438.38,2246.18l-2.46,1.53C3436.08,2246.14,3436.88,2245.6,3438.38,2246.18Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M3346.44,2312.23l-2.5,1.54C3344.09,2312.15,3344.92,2311.63,3346.44,2312.23Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-8"
          d="M2100,3624l1.48,2.24C2100.05,3626.06,2099.49,3625.36,2100,3624Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-4"
          d="M2044.16,3485.7l1.07,2.45C2043.83,3487.78,2043.51,3487,2044.16,3485.7Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-9"
          d="M3314.3,3300.5c-174.8-.15-316-141.43-316-316.17,0-174.4,141.87-316.15,316.29-316,174.62.11,316,141.7,315.83,316.35C3630.29,3159.55,3489.07,3300.65,3314.3,3300.5ZM3099,2784.73a34.76,34.76,0,0,0-3.73,3.25,317.73,317.73,0,0,0-55.19,91c-1.66,4.14-1,7.69.13,11.54q28.72,94,0,187.95a18.68,18.68,0,0,0,.59,13.41,320.5,320.5,0,0,0,35.89,65.58c6.76,9.45,13.56,18.91,22.09,27.07C3164.9,3075.91,3171,2906.65,3099,2784.73Z"
          transform="translate(-1500 -1500)"
        />
        <path
          class="cls-8"
          d="M3250.67,2577.18c-.74,1.7-2.52,1.31-4,1.29a1.13,1.13,0,0,1-.77-2,6.53,6.53,0,0,1,3.34-1.47C3250.25,2574.92,3250.83,2575.87,3250.67,2577.18Z"
          transform="translate(-1500 -1500)"
        />
        <path
          :class="colorClass"
          d="M3099,2784.73c72,121.92,65.92,291.18-.26,399.78-8.53-8.16-15.33-17.62-22.09-27.07a320.5,320.5,0,0,1-35.89-65.58,18.68,18.68,0,0,1-.59-13.41q28.82-93.93,0-187.95c-1.17-3.85-1.79-7.4-.13-11.54a317.73,317.73,0,0,1,55.19-91A34.76,34.76,0,0,1,3099,2784.73Z"
          transform="translate(-1500 -1500)"
        />
      </svg>
    </svg>
  </div>
</template>

<script>
export default {
  name: "icon",
  props: {
    width: Number,
    height: Number,
    colorClass: String,
    link: String,
  },
  methods: {
    handleLink: function () {
      if (this.link) {
        this.$router.push(this.link);
      }
    },
  },
  computed: {
    svgWidth: function () {
      if (this.width && this.width > 0) {
        return this.width;
      }
      return "100%";
    },
    svgHeight: function () {
      if (this.height && this.height > 0) {
        return this.height;
      }
      return "100%";
    },
  },
};
</script>

<style type="text/css">
.primary {
  fill: var(--v-primary-base);
}
.secondary {
  fill: var(--v-secondary-base);
}
.text {
  fill: var(--v-text-base);
}
.background {
  fill: var(--v-background-base);
}
.white {
  fill: #ffffff;
}
.black {
  fill: #000000;
}
.cls-1 {
  fill: transparent;
}
.cls-2 {
  fill: #162183;
}
.cls-3 {
  fill: #3fad3d;
}
.cls-4 {
  fill: transparent;
}
.cls-5 {
  fill: transparent;
}
.cls-6 {
  fill: transparent;
}
.cls-7 {
  fill: transparent;
}
.cls-8 {
  fill: transparent;
}
.cls-9 {
  fill: transparent;
}
</style>
